module.exports = __webpack_public_path__ + "img/credit-three.4c8cc316.svg";